import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import OurFeatures from "../../components/OurFeatures";
import HomeSlider from "../../components/HomeSlider";
import OurServices from "../../components/OurServices";
import FeaturedProducts from "../../components/FeaturedProducts";
import BrandLogoSlider from "../../components/BrandLogoSlider";
import Footer from "../../components/Footer";
import Modal from 'react-bootstrap/Modal';
import CostCenterAndCatalog from '../../components/Dashboard/CostCenterAndCatalog';
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import { useSelector, useDispatch } from 'react-redux'
import * as AuthVerify from '../../lib/common';
// import $ from "jquery";

import './Home.styles.css';
import { Container } from 'react-bootstrap';



const Home = () => {

	const [showCCaCModel, setShowCCaCModel] = useState(false);
	
	const compare = useSelector(state => state.compare);
	const dispatch = useDispatch();

	// useEffect(() => {
	// 	$(document).ready(function(){
	// 		$("button").click(function(){
	// 		  $("p").toggle();
	// 		});
	// 	  });

	// 	  $(document).ready(function () {
	// 		$('#jtv-rev_slider').show().revolution({
	// 		  dottedOverlay: 'none',
	// 		  delay: 5000,
	// 		  startwidth: 850,
	// 		  startheight: 450,
	// 		  hideThumbs: 200,
	// 		  thumbWidth: 200,
	// 		  thumbHeight: 50,
	// 		  thumbAmount: 2,
	// 		  navigationType: 'thumb',
	// 		  navigationArrows: 'solo',
	// 		  navigationStyle: 'round',
	// 		  touchenabled: 'on',
	// 		  onHoverStop: 'on',
	// 		  swipe_velocity: 0.7,
	// 		  swipe_min_touches: 1,
	// 		  swipe_max_touches: 1,
	// 		  drag_block_vertical: false,
	// 		  spinner: 'spinner0',
	// 		  keyboardNavigation: 'off',
	// 		  navigationHAlign: 'center',
	// 		  navigationVAlign: 'bottom',
	// 		  navigationHOffset: 0,
	// 		  navigationVOffset: 20,
	// 		  soloArrowLeftHalign: 'left',
	// 		  soloArrowLeftValign: 'center',
	// 		  soloArrowLeftHOffset: 20,
	// 		  soloArrowLeftVOffset: 0,
	// 		  soloArrowRightHalign: 'right',
	// 		  soloArrowRightValign: 'center',
	// 		  soloArrowRightHOffset: 20,
	// 		  soloArrowRightVOffset: 0,
	// 		  shadow: 0,
	// 		  fullWidth: 'on',
	// 		  fullScreen: 'off',
	// 		  stopLoop: 'off',
	// 		  stopAfterLoops: -1,
	// 		  stopAtSlide: -1,
	// 		  shuffle: 'off',
	// 		  autoHeight: 'off',
	// 		  forceFullWidth: 'on',
	// 		  fullScreenAlignForce: 'off',
	// 		  minFullScreenHeight: 0,
	// 		  hideNavDelayOnMobile: 1500,
	// 		  hideThumbsOnMobile: 'off',
	// 		  hideBulletsOnMobile: 'off',
	// 		  hideArrowsOnMobile: 'off',
	// 		  hideThumbsUnderResolution: 0,
	// 		  hideSliderAtLimit: 0,
	// 		  hideCaptionAtLimit: 0,
	// 		  hideAllCaptionAtLilmit: 0,
	// 		  startWithSlide: 0,
	// 		  fullScreenOffsetContainer: ''
	// 		});
	// 	  });
	// }, []);

	useEffect(() => {
		var userDetails=AuthVerify.getUser();
		if(userDetails?.ccacNotNotified && userDetails.role=='Corporate'){
			setShowCCaCModel(true);
			userDetails.ccacNotNotified=false;
			AuthVerify.setSession(userDetails);
		}
	}, []);
 
	return (
		<div> 
			<Helmet>
				<title>Home</title>
				<meta name="description" content="E-Commerce" />
				<meta property="og:image" content="%PUBLIC_URL%"/>
				<meta property="og:title" content="E-Commerce"/>
				<meta name="title" content="E-Commerce"/>
				<meta property="og:description" content="E-Commerce" />
				<meta property="og:url" content="%PUBLIC_URL%"/>
			</Helmet>
			<Header reducer={compare} dispatch={dispatch}/>
            <ActiveCatalogue reducer={compare} dispatch={dispatch}/>
			<Container>
				<OurFeatures reducer={compare} dispatch={dispatch} />
				<HomeSlider reducer={compare} dispatch={dispatch} />
				<FeaturedProducts reducer={compare} dispatch={dispatch} />
				<OurServices reducer={compare} dispatch={dispatch} />
			</Container> 
			<BrandLogoSlider reducer={compare} dispatch={dispatch}/>
			<Footer reducer={compare} dispatch={dispatch}/>

			<Modal show={showCCaCModel} dialogClassName="modal-90w" centered={true} animation={false} fade={false} style={{opacity:1}} onHide={()=>setShowCCaCModel(false)}>
				<Modal.Header closeButton={false}>
				<Modal.Title>Update your Cost Center and Catalog</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{textAlign:"center"}}>
					<CostCenterAndCatalog/>
				</Modal.Body>
				<Modal.Footer>
				<div className="">
					<button
						className="button btn-proceed-checkout btn-danger"
						title="Proceed to Checkout"
						type="button"
						onClick={() => setShowCCaCModel(false)}
						style={{
							marginRight: "10px",
							padding: "10px"
						}}
						>
						<span>Close</span>
					</button>
				</div>
				</Modal.Footer>
			</Modal>
		</div>

	);

};
export default Home;